import  request  from '@/utils/request'

export function index(params) {
    return request({
        url: '/finance/accounts',
        method: 'get',
        params: params
    })
}
export function inventory(params) {
    return request({
        url: '/finance/account/inventory',
        method: 'get',
        params
    })
}
export function show(id) {
    return request({
        url: `/finance/accounts/${id}`,
        method: 'get'
    })
}
export function store(data) {
    return request({
        url:  '/finance/accounts',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `/finance/accounts/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `/finance/accounts/${id}`,
        method: 'delete'
    })
}
